import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { 
  fetchDashboardSummary, 
  fetchSubscriptions, 
  fetchCategories,
  createSubscription,
  updateSubscription,
  deleteSubscription,
  pauseSubscription,
  resumeSubscription
} from '../lib/api';

// ダッシュボードサマリーデータを取得するフック
export const useDashboardSummary = () => {
  return useQuery({
    queryKey: ['dashboard', 'summary'],
    queryFn: fetchDashboardSummary,
    staleTime: 1000 * 60 * 5, // 5分間はフレッシュ
    retry: 2,
  });
};

// サブスクリプション一覧を取得するフック
export const useSubscriptions = (categoryId?: number) => {
  return useQuery({
    queryKey: ['subscriptions', { categoryId }],
    queryFn: () => fetchSubscriptions(0, 100, categoryId),
    staleTime: 1000 * 60 * 2, // 2分間はフレッシュ
    retry: 2,
  });
};

// カテゴリ一覧を取得するフック
export const useCategories = () => {
  return useQuery({
    queryKey: ['categories'],
    queryFn: fetchCategories,
    staleTime: 1000 * 60 * 10, // 10分間はフレッシュ
    retry: 2,
  });
};

// サブスクリプション作成のフック
export const useCreateSubscription = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: createSubscription,
    onSuccess: () => {
      // 作成成功時にキャッシュを無効化してデータを再取得
      queryClient.invalidateQueries({ queryKey: ['dashboard', 'summary'] });
      queryClient.invalidateQueries({ queryKey: ['subscriptions'] });
    },
  });
};

// サブスクリプション更新のフック
export const useUpdateSubscription = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: updateSubscription,
    onSuccess: () => {
      // 更新成功時にキャッシュを無効化してデータを再取得
      queryClient.invalidateQueries({ queryKey: ['dashboard', 'summary'] });
      queryClient.invalidateQueries({ queryKey: ['subscriptions'] });
    },
  });
};

// サブスクリプション削除のフック
export const useDeleteSubscription = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: deleteSubscription,
    onSuccess: () => {
      // 削除成功時にキャッシュを無効化してデータを再取得
      queryClient.invalidateQueries({ queryKey: ['dashboard', 'summary'] });
      queryClient.invalidateQueries({ queryKey: ['subscriptions'] });
    },
  });
};

// サブスクリプション一時停止のフック
export const usePauseSubscription = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: pauseSubscription,
    onSuccess: () => {
      // 一時停止成功時にキャッシュを無効化してデータを再取得
      queryClient.invalidateQueries({ queryKey: ['dashboard', 'summary'] });
      queryClient.invalidateQueries({ queryKey: ['subscriptions'] });
    },
  });
};

// サブスクリプション再開のフック
export const useResumeSubscription = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: resumeSubscription,
    onSuccess: () => {
      // 再開成功時にキャッシュを無効化してデータを再取得
      queryClient.invalidateQueries({ queryKey: ['dashboard', 'summary'] });
      queryClient.invalidateQueries({ queryKey: ['subscriptions'] });
    },
  });
};
